module.exports = __webpack_public_path__ + "img/dk.af26fb0e.svg";